module.exports = __webpack_public_path__ + "static/media/CS_JAN24_-105.2fb0eadb.jpg";